<template>
    <div>
        <v-alert v-for="(errorMessage, index) in this.messages" :key="`errorMessage-${index}`" type="error">
            {{ errorMessage }}
        </v-alert>
    </div>
</template>

<script>
export default {
    name: 'v-error-messages',
    components: {},
    props: {
        messages: Array,
    },
    data: () => ({}),
};
</script>
